const state = {
  snackbarstatic: {
    showing: false,
    text: "",
    color: "",
  },
};

const getters = {
  retrieveSnackbar: (state) => {
    return state.snackbarstatic;
  },
};

const actions = {
  setSnackbar({ commit }, snackbar) {
    snackbar.showing = true;
    snackbar.color = snackbar.color || "success";

    commit("SET_SNACKBAR", snackbar);
  },

  resetSnackbar({ commit }) {
    let snackbar = {};

    snackbar.showing = false;
    snackbar.text = "";
    snackbar.color = snackbar.color || "success";

    commit("SET_SNACKBAR", snackbar);
  },
};

const mutations = {
  SET_SNACKBAR(state, snackbar) {
    state.snackbarstatic = snackbar;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
